export default __webpack_public_path__ + "static/media/04_TheBox.02eb05eb.jpg";